import { IApplicationState } from '../../types/redux';

export function getOfferType(state: IApplicationState) {
  const { tab } = state;

  return state[tab].filters.offerType || [];
}
